/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('memoCtrl', ['$scope', '$http', 'NetworkService','MainService', function ($scope, $http, networkService, MainService) {
        
        
        var email = MainService.getEmail();
        networkService.getNotes(email, function(data){
            console.log(data.notes)
            $scope.memos = data.notes
        });
        $scope.addNote = function()
        {
            networkService.addNote(MainService.getEmail(), $scope.noteModel);
        }
}])